"use strict";

var _classCallCheck = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Base = require("../styles/Base");

var _InlineInput = _interopRequireDefault(require("../widgets/InlineInput"));

var _Tag = _interopRequireDefault(require("./Card/Tag"));

var _DeleteButton = _interopRequireDefault(require("../widgets/DeleteButton"));

var Card = /*#__PURE__*/function (_react$Component) {
  _inherits(Card, _react$Component);

  function Card() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Card)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)(_assertThisInitialized(_assertThisInitialized(_this)), "onDelete", function (e) {
      _this.props.onDelete();

      e.stopPropagation();
    });
    return _this;
  }

  _createClass(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showDeleteButton = _this$props.showDeleteButton,
          style = _this$props.style,
          tagStyle = _this$props.tagStyle,
          onClick = _this$props.onClick,
          onDelete = _this$props.onDelete,
          onChange = _this$props.onChange,
          className = _this$props.className,
          id = _this$props.id,
          title = _this$props.title,
          label = _this$props.label,
          description = _this$props.description,
          tags = _this$props.tags,
          cardDraggable = _this$props.cardDraggable,
          editable = _this$props.editable,
          t = _this$props.t;

      var updateCard = function updateCard(card) {
        onChange((0, _objectSpread2.default)({}, card, {
          id: id
        }));
      };

      return _react.default.createElement(_Base.MovableCardWrapper, {
        "data-id": id,
        onClick: onClick,
        style: style,
        className: className
      }, _react.default.createElement(_Base.CardHeader, null, _react.default.createElement(_Base.CardTitle, {
        draggable: cardDraggable
      }, editable ? _react.default.createElement(_InlineInput.default, {
        value: title,
        border: true,
        placeholder: t('placeholder.title'),
        resize: "vertical",
        onSave: function onSave(value) {
          return updateCard({
            title: value
          });
        }
      }) : title), _react.default.createElement(_Base.CardRightContent, null, editable ? _react.default.createElement(_InlineInput.default, {
        value: label,
        border: true,
        placeholder: t('placeholder.label'),
        resize: "vertical",
        onSave: function onSave(value) {
          return updateCard({
            label: value
          });
        }
      }) : label), showDeleteButton && _react.default.createElement(_DeleteButton.default, {
        onClick: this.onDelete
      })), _react.default.createElement(_Base.Detail, null, editable ? _react.default.createElement(_InlineInput.default, {
        value: description,
        border: true,
        placeholder: t('placeholder.description'),
        resize: "vertical",
        onSave: function onSave(value) {
          return updateCard({
            description: value
          });
        }
      }) : description), tags && tags.length > 0 && _react.default.createElement(_Base.Footer, null, tags.map(function (tag) {
        return _react.default.createElement(_Tag.default, (0, _extends2.default)({
          key: tag.title
        }, tag, {
          tagStyle: tagStyle
        }));
      })));
    }
  }]);

  return Card;
}(_react.Component);

Card.propTypes = {
  showDeleteButton: _propTypes.default.bool,
  onDelete: _propTypes.default.func,
  onClick: _propTypes.default.func,
  style: _propTypes.default.object,
  tagStyle: _propTypes.default.object,
  className: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  description: _propTypes.default.string,
  tags: _propTypes.default.array
};
Card.defaultProps = {
  showDeleteButton: true,
  onDelete: function onDelete() {},
  onClick: function onClick() {},
  style: {},
  tagStyle: {},
  title: 'no title',
  description: '',
  label: '',
  tags: [],
  className: ''
};
var _default = Card;
exports.default = _default;